/**
 * Obviously synthetic sample — not a real credential.
 * alg: none, kid: SAMPLE-ONLY, expired exp for status demonstration.
 */

export function base64UrlEncodeUtf8(value: string): string {
	const bytes = new TextEncoder().encode(value);
	let binary = '';
	for (const b of bytes) {
		binary += String.fromCharCode(b);
	}
	return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

const SAMPLE_HEADER = {
	alg: 'none',
	typ: 'JWT',
	kid: 'SAMPLE-ONLY',
};

const SAMPLE_PAYLOAD = {
	iss: 'https://example.invalid/dummy',
	sub: 'dummy-user-not-real',
	aud: 'demo-app',
	iat: 1516239022,
	nbf: 1516239022,
	exp: 1516242622,
	name: 'Dummy Token',
};

export const SAMPLE_JWT = [
	base64UrlEncodeUtf8(JSON.stringify(SAMPLE_HEADER)),
	base64UrlEncodeUtf8(JSON.stringify(SAMPLE_PAYLOAD)),
	'',
].join('.');
